import request from '@/utils/request'

//医院采集器列表
export function queryEqpList(data) {
  return request({
    url: '/db/hosp/hosp-collector-query',
    method: 'post',
    data
  })
}

export function queryHospCollectCount(data) {
  return request({
    url: '/db/hosp/hosp-collector-count-query',
    method: 'post',
    data
  })
}

// 采集节点图表查询
export function queryChartQuery(data) {
  return request({
    url: '/db/collector/sensor-chart-query',
    method: 'post',
    data
  })
}

// 采集节点历史图表查询
export function historyChartQuery(data) {
  return request({
    url: '/db/collector/sensor-history-chart-query',
    method: 'post',
    data
  })
}

// 设备主机信息更新
export function eqpHostInfoUpdate(data) {
  return request({
    url: '/api/eqp-host-info/update',
    method: 'post',
    data,
  })
}


// 日志图表查询
export function eqpLogChartQuery(data) {
  return request({
    url: '/api/eqp-log-chart/chart-list-query',
    method: 'post',
    data
  })
}

// 采集型设备基本信息查询
export function daqTypeEqpInfoQuery(data) {
  return request({
    url: '/api/eqp-log/daq-type-eqp-info-query',
    method: 'get',
    params:data,
  })
}

// GE MR 事件日志查询
export function geMrEventLogQuery(data) {
  return request({
    url: '/api/ge-mr-event-log/paged-query',
    method: 'post',
    data,
  })
}

// 飞利浦CT事件日志查询
export function philipsCtEventLogQuery(data) {
    return request({
        url: '/api/philips-ct-event-log/paged-query',
        method: 'post',
        data,
    })
}
// 飞利浦MR事件日志查询
export function philipsMrEventLogQuery(data) {
    return request({
        url: '/api/philips-mr-event-log/paged-query',
        method: 'post',
        data,
    })
}

export function eqpHostInfoQuery(data) {
  return request({
    url: '/api/eqp-host-info/eqp-id-query',
    method: 'get',
    params:data
  })
}


export function updateInstallationCd(data) {
  return request({
    url: '/api/eqp-host-info/update-installation-cd',
    method: 'post',
    data
  })
}


export function updateBackupParameter(data) {
  return request({
    url: '/api/eqp-host-info/update-backup-parameter',
    method: 'post',
    data
  })
}


export function eqpLogReport(data) {
  return request({
    url: '/api/eqp-log-chart/eqp-log-report',
    method: 'post',
    data
  })
}